module.exports = __webpack_public_path__ + "img/sel-logo-dark-bg.a7dadbbe.svg";